module.exports = __webpack_public_path__ + "static/media/Edit.0e5a0088.png";